import styled from 'styled-components';

export const Header = styled.h1`
font-size: 60px
`;
export const Container = styled.div`
display: flex;
flex-direction: column;
background: none;
padding-top: 61px;
height: fit-content;
`;